import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-364a3dcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-container" }
const _hoisted_2 = { class: "auth-page" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "auth-page__buttons-container" }
const _hoisted_5 = { class: "auth-page__buttons-text" }

import { IonContent, IonPage, IonIcon } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { logEvent } from '@/services/analytics';
import { useInternalization } from '@/composables/useInternalization';

import TheHeader from '@/components/TheHeader.vue';
import BaseButton from '@/components/BaseButton.vue';
import AuthBanner from '@/components/AuthBanner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthPage',
  setup(__props) {

const router = useRouter();
const { t } = useInternalization();

logEvent('view_auth-page');

function handleSigninClick() {
  router.push({ name: 'SignIn' });
}
function handleSignupClick() {
  router.push({ name: 'SignUp' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(TheHeader, { "show-avatar": false }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonIcon), { src: "/assets/icon/auth-logo-icon.svg" })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(AuthBanner, { class: "auth-page__bunner" }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(BaseButton, {
                  class: "auth-page__button auth-page__button--signup",
                  secondary: "",
                  onClick: handleSignupClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('signUp')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('authButtonsText')), 1),
                _createElementVNode("div", {
                  class: "auth-page__button auth-page__button--signin",
                  onClick: handleSigninClick
                }, _toDisplayString(_unref(t)('signIn')), 1)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})